import LayerAPI from '@/api/layer'
import UserAPI from '@/api/user'
import _ from 'lodash'

// initial state
const state = {
  layers: [],
  selectedLayers: []
}

// getters
const getters = {
  getAll (state) {
    return state.layers
  },
  get (state) {
    return (layerId) => _.find(state.layers, { id: layerId })
  },
  getAllSelected (state) {
    return state.selectedLayers
  },
  getAllActiveSelected (state) {
    return state.selectedLayers.filter(x => x.active === true)
  }
}

// actions
const actions = {
  async fetchAll (store) {
    const response = await LayerAPI.getList()
    store.commit('setLayers', response.layers)
    store.commit('setSortedLayers', response.sortedLayers)

    return response
  },
  setLayers (store, data) {
    store.commit('setLayers', data)
    store.commit('sortSelectedLayer')
    UserAPI.updateLayerSettings(state.selectedLayers)
  },
  selectOrUnselect (store, data) {
    if (data.value) {
      store.commit('addSelectedLayer', data.layer.id)
      store.commit('sortSelectedLayer')
    } else {
      store.commit('removeSelectedLayer', data.layer.id)
    }
    UserAPI.updateLayerSettings(state.selectedLayers)
  }
}

// mutations
const mutations = {
  setLayers (state, layers) {
    state.layers = layers
  },
  setSortedLayers (state, layers) {
    state.selectedLayers = []

    // add already selected layers to user selection
    for (let l = 0; l < layers.length; l++) {
      if (state.layers.find(x => x.id === layers[l].id)) {
        state.selectedLayers.push(layers[l])
      }
    }

    // add all the rest to user selection
    for (let l = 0; l < state.layers.length; l++) {
      if (!state.selectedLayers.find(x => x.id === state.layers[l].id)) {
        state.selectedLayers.push({ id: state.layers, active: false })
      }
    }

    // sort original layers by user settings
    let sortIds = state.selectedLayers.map(l => l.id)
    state.layers = state.layers.sort(function (a, b) {
      let A = a['id']
      let B = b['id']
      if (sortIds.indexOf(A) > sortIds.indexOf(B)) {
        return 1
      } else {
        return -1
      }
    })
  },
  addSelectedLayer (state, layerId) {
    let index = state.selectedLayers.findIndex(x => x.id === layerId)
    if (index === -1) {
      state.selectedLayers.push({ id: layerId, active: true })
      return
    } else if (state.selectedLayers[index].active === true) {
      return
    }

    state.selectedLayers[index].active = true
  },
  sortSelectedLayer (state) {
    let activeIds = state.selectedLayers.filter(l => l.active === true).map(l => l.id)
    state.selectedLayers = []
    for (let i = 0; i < state.layers.length; i++) {
      let id = state.layers[i].id
      state.selectedLayers.push({ id, active: (activeIds.indexOf(id) > -1) })
    }
  },
  removeSelectedLayer (state, layerId) {
    let index = state.selectedLayers.findIndex(x => x.id === layerId)
    if (index && state.selectedLayers[index].active === false) {
      return
    }
    state.selectedLayers[index].active = false
  },
  initialise (state) {
    if (localStorage.getItem('layer.selected')) {
      // state.selectedLayers = JSON.parse(localStorage.getItem('layer.selected'))
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
